let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bLCoT")).then(() => parcelRequire('dIHua'));